<template>
	<div class="rich-text" v-html="text">
	</div>
</template>

<script>
    export default {
        name: "RichText",
		props:{
            text: ""
		}
    }
</script>

<style lang="scss">
	.rich-text {
		
		margin-bottom: 20px;
		
		p {
			font-size: 16px;
			font-weight: normal;
			color: #000;
			line-height: 30px;
			margin-bottom: 20px;
		}
		
		table {
			
			font-size: 16px;
			line-height: 1.5;
			border-top: 1px solid #ccc;
			border-left: 1px solid #ccc;
			
			th {
				border-bottom: 2px solid #ccc;
				border-right: 1px solid #ccc;
				text-align: center;
			}
			
			td, th {
				border-bottom: 1px solid #ccc;
				border-right: 1px solid #ccc;
				padding: 3px 5px;
			}
			
		}
	}
</style>